import React from 'react'

// Logo 因为非常重要，所以独立出来成为单独的组件
const Logo = (props) => {
  const { src, width, height, name } = props
  
  return (
    <logo>
      <img className="site-logo" src={ src }
           alt={ name }
           title={ name } />
    </logo>
  )
}

export default Logo


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/media/logo/index.js